var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00584 8L0.990841 13.015C0.726985 13.2804 0.578885 13.6395 0.578885 14.0138C0.578885 14.388 0.726985 14.7471 0.990841 15.0125C1.12254 15.1453 1.27922 15.2507 1.45186 15.3226C1.62449 15.3945 1.80966 15.4315 1.99667 15.4315C2.18369 15.4315 2.36886 15.3945 2.54149 15.3226C2.71413 15.2507 2.87081 15.1453 3.00251 15.0125L9.00918 9.00584C9.14196 8.87414 9.24735 8.71745 9.31927 8.54482C9.39119 8.37219 9.42822 8.18702 9.42822 8C9.42822 7.81298 9.39119 7.62782 9.31927 7.45518C9.24735 7.28255 9.14196 7.12587 9.00918 6.99417L3.00251 0.916669C2.87013 0.78537 2.71314 0.681494 2.54054 0.610993C2.36794 0.540494 2.18312 0.504756 1.99667 0.505835C1.81023 0.504756 1.62541 0.540494 1.45281 0.610993C1.2802 0.681494 1.12321 0.78537 0.990841 0.916669C0.726985 1.1821 0.578885 1.54116 0.578885 1.91542C0.578885 2.28968 0.726985 2.64874 0.990841 2.91417L6.00584 8Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.23f5f9934f09f4d34bf15e1114043c04.svg";
export { ForwardRef as ReactComponent };